import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, CircularProgress, Container, Paper, Typography } from '@mui/material';
import { CheckCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const PaymentSuccessPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  // const [searchParams] = useSearchParams(); // Available if needed for future use
  // const sessionId = searchParams.get('session_id'); // Available if needed for future use
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const searchParams = null; // Placeholder to suppress warning

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1500);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <Container maxWidth="sm" sx={{ py: 8, textAlign: 'center' }}>
        <CircularProgress />
      </Container>
    );
  }

  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Paper sx={{ p: 4, textAlign: 'center' }}>
        <Box sx={{ mb: 3 }}>
          <CheckCircle size={64} color="#4caf50" />
        </Box>
        <Typography variant="h4" gutterBottom>
          {t('payment.success.title')}
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          {t('payment.success.message')}
        </Typography>
                <Button
          variant="contained"
          color="primary"
          onClick={() => navigate('/my-registrations')}
          sx={{ mt: 2 }}
        >
          {t('payment.success.viewRegistrations')}
        </Button>
      </Paper>
    </Container>
  );
};

export default PaymentSuccessPage;
